import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import {
  selectedVariantId,
  productData,
  changeVariant,
} from "../store/product-store";

@customElement("variant-selects")
export class VariantSelect extends LitElement {
  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }
  // Method to update the global signal
  _onVariantChange(e: Event) {
    const select = e.target as HTMLSelectElement;
    changeVariant(parseInt(select.value));
    // Note: URL sync now handled in changeVariant() action
  }

  render() {
    const variants = productData.value?.variants || [];
    const optionLabel = (productData.value?.options || []).join(" / ");

    return html`
      <div class="product-form__input product-form__input--dropdown w-full rounded-sm border border-[var(--color-neutral-300)] bg-white transition-colors duration-200 focus-within:border-[var(--color-secondary-500)] focus-within:ring-2 focus-within:ring-[var(--color-secondary-200)]">
        <div class="select relative">
          ${optionLabel
            ? html`<span
                class="pointer-events-none absolute left-4 top-4 z-10 block text-caption text-[var(--color-neutral-400)]"
                >${optionLabel}</span
              >`
            : null}
          <select
            @change=${this._onVariantChange}
            class="peer select__select w-full appearance-none pt-[40px] pb-4 pr-10 pl-4 text-sm font-semibold uppercase leading-none text-[var(--color-neutral-700)] outline-none tracking-wider"
          >
            ${variants.map(
              (v: any) => html`
                <option
                  value="${v.id}"
                  ?selected=${selectedVariantId.value === v.id}
                >
                  ${v.title}
                </option>
              `
            )}
          </select>
          <svg
            aria-hidden="true"
            focusable="false"
            viewBox="0 0 10 6"
            class="pointer-events-none absolute right-4 top-1/2 h-[8px] w-[14px] -translate-y-1/2 text-[var(--color-neutral-700)] transition-colors duration-200 peer-focus:text-[var(--color-secondary-500)]"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
      </div>
    `;
  }
}
